import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../api/axios';
import './ForgotPassword.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      if (err.response?.status === 429) {
        setError('Too many requests. Please wait before trying again.');
      } else {
        setSubmitted(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-root">
      {/* Left — background image */}
      <div className="fp-left" />

      {/* Right — form */}
      <div className="fp-right">
        <div className="fp-card">
          {/* Brand */}
          <div className="fp-brand">
            <div className="fp-logo">🏗</div>
            <span className="fp-brand-name">Construction ERP</span>
          </div>

          {submitted ? (
            <div className="fp-success">
              <div className="fp-success-icon">✉️</div>
              <h2>Check your email</h2>
              <p>
                If this email is registered, a temporary password has been sent.
                Please check your inbox.
              </p>
              <Link to="/login" className="fp-back-link">← Back to Sign In</Link>
            </div>
          ) : (
            <>
              <div className="fp-header">
                <h2 className="fp-title">Forgot Password</h2>
                <p className="fp-sub">
                  Enter your email address and we'll send you a temporary password.
                </p>
              </div>

              {error && <div className="fp-error">{error}</div>}

              <form onSubmit={handleSubmit} className="fp-form">
                <div className="fp-field">
                  <label htmlFor="fp-email">Email address</label>
                  <input
                    id="fp-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@company.com"
                    required
                    disabled={loading}
                    autoComplete="email"
                  />
                </div>

                <button type="submit" className="fp-submit" disabled={loading}>
                  {loading ? 'Sending…' : 'Send Temporary Password'}
                </button>
              </form>

              <p className="fp-footer">
                <Link to="/login" className="fp-link">← Back to Sign In</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
